export const DEFAULT_PARAMETER_NAME_REGEX = /^parameter(\d+)?$/;

export default function isDefaultSystemName(name: string): boolean {
  return name.match(DEFAULT_PARAMETER_NAME_REGEX) != null;
}
